export enum GridPersistedElements {
  Filter = 'filter',
  Sort = 'sort',
  Pagesize = 'pagesize',
  Selection = 'selection',
  SelectionFamily = 'selection-family',
  Settings = 'settings',
  TimeBarDates = 'timeBarDates',
}
